module.exports = __webpack_public_path__ + "static/media/archWindow.eefb9c0c.jpg";